const Joi = require("joi");

const managementUserSchema = Joi.object({
  UserRoleID: Joi.number()
    .min(1) // Ensures Role cannot be 0
    .required()
    .messages({
      "any.required": "Please select Role.", // Error message when value is not provided
      "number.base": "Please select Role.", // Error message if the role is not a valid number
      "number.min": "Please select Role.", // Error message if Role is less than 1
    }),
  FirstName: Joi.string()
    .min(1) // Ensures FirstName has at least 1 character
    .required()
    .trim()
    .messages({
      "any.required": "Please enter First Name.", // Error message when FirstName is not provided
      "string.min": "Please enter First Name.", // Error message if FirstName has fewer than 1 character
      "string.empty": "Please enter First Name.",
    }),
  LastName: Joi.string()
    .min(1) // Ensures LastName has at least 1 character
    .required()
    .trim()
    .messages({
      "any.required": "Please enter Last Name.", // Error message when LastName is not provided
      "string.min": "Please enter Last Name.", // Error message if LastName has fewer than 1 character
      "string.empty": "Please enter Last Name.",
    }),
  Username: Joi.string()
    .min(1) // Ensures Username has at least 1 character
    .required()
    .trim()
    .messages({
      "any.required": "Please enter Username.", // Error message when Username is not provided
      "string.min": "Please enter Username.", // Error message if Username has fewer than 1 character
      "string.empty": "Please enter Username.",
    }),
  UserPassword: Joi.string()
    .pattern(new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,})")) // At least 8 characters, with at least one letter and one number
    .required()
    .trim()
    .messages({
      "string.pattern.base":
        "Password should contain letter, numbers and minimum 8 characters.",
      "any.required": "Please enter Password.",
      "string.empty": "Please enter Password.",
    }),
  // Email validation
  Email: Joi.string()
    .allow("") // Allow empty strings
    .trim()
    .email({ tlds: { allow: false } })
    .pattern(
      new RegExp(
        // "^[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,4})$"
         /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
      )
    )
    .messages({
      "string.email": "Please enter valid E-mail.",
      "string.empty": "Please enter valid E-mail.",
      "string.pattern.base": "Please enter valid E-mail.",
    }),

  // PhoneNumber validation (US format)
  PhoneNumber: Joi.string()
    .allow("") // Allow empty strings
    .trim()
    .pattern(new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
    .messages({
      "string.pattern.base": "Please enter valid Phone Number.",
    }),

  // ZIP validation (exactly 5 digits)
  ZIP: Joi.string()
    .allow("") // Allow empty strings
    .pattern(new RegExp(/^[0-9]{5}$/))
    .messages({
      "string.pattern.base":
        "Please enter a ZIP code that contains exactly 5 digits.",
    }),
}).unknown(true);

module.exports = managementUserSchema;